export function findMinMaxValues<T extends object>(array: T[]) {
	let min = 0;
	let max = 0;
	for (const item of array) {
		const values = Object.values(item);
		for (const value of values) {
			if (typeof value !== "number") continue;
			if (value < min) min = value;
			if (value > max) max = value;
		}
	}
	return { min, max };
}
